import { useState } from 'react';
import pharmacy from 'services/pharmacy';

export default () => {
  const [medicationFromName, setMedicationFromName] = useState([]);
  const [formsFromMedication, setFormsFromMedication] = useState([]);
  const [strengthsFromMedicationAndForm, setStrengthsFromMedicationAndForm] = useState([]);

  const getMedicationFromName = async (medicationName) => {
    try {
      if (medicationName.length >= 3) {
        const response = await pharmacy.post(`/medications/names`, {
          name: medicationName,
        });
        setMedicationFromName(response.data);
      } else {
        setMedicationFromName([]);
      }
    } catch (e) {
      throw e;
    }
  };

  const getFormsFromMedication = async (medication) => {
    try {
      const response = await pharmacy.post(`/medications/forms`, medication);
      setFormsFromMedication(response.data);
    } catch (e) {
      throw e;
    }
  };

  const getStrengthsFromMedicationAndForm = async (medication, form) => {
    try {
      const request = {
        name: medication.name,
        form: form,
      };
      const response = await pharmacy.post(`/medications/strengths`, request);
      setStrengthsFromMedicationAndForm(response.data);
    } catch (e) {
      throw e;
    }
  };

  return [
    medicationFromName,
    formsFromMedication,
    strengthsFromMedicationAndForm,
    getMedicationFromName,
    getFormsFromMedication,
    getStrengthsFromMedicationAndForm,
  ];
};
